import React from "react";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import CarsIcon from '../../Assets/vidaslogo.svg'

export function NavbarComp (props) {
    return (
        <Container fluid='xl'>
            <Navbar collapseOnSelect expand="lg" bg="black" variant="dark">
                <Navbar.Brand href="/VidaTrans">
                    <img src={CarsIcon} width={props.size + 'rem'} alt="Vida Trans" style={{margin : '1rem'}} />
                    <span>Vida Trans</span>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Navbar.Collapse className="justify-content-end">
                    <Nav>
                        <Nav.Link href="#features">Features</Nav.Link>
                        <Nav.Link href="#testimoni">Testimoni</Nav.Link>
                    </Nav>
                    </Navbar.Collapse>
                </Navbar.Collapse>
            </Navbar>
        </Container>
    )
}

